import React, { useState, useRef } from 'react';
import Select from 'react-select';
import { FormHelperText } from '@material-ui/core';
import { ErrorMessage } from 'formik';
import { useUnitScales } from 'hook/units/scales';
import { customStyles } from './styles';
import moment from 'moment';
import debounce from 'lodash.debounce';

const CustomSelectScales = ({
  name,
  field,
  placeholder,
  handleChange,
  value,
  menuList,
  errors,
  showCount = false,
  isMulti = false,
  isClearable = false,
  unit_id = null,
}) => {
  const { data, loading, getScalesByUnitIds } = useUnitScales();
  const [filter, setFilter] = useState({
    page: 1,
    per_page: 60,
    search: '',
    date_start: showCount ? moment().day(1).format('yyyy-MM-DD') : undefined,
    date_end: showCount ? moment().day(7).format('yyyy-MM-DD') : undefined,
  });
  const [formattedLabels, setFormattedLabels] = useState([]);

  const debouncedGetScales = useRef(
    debounce((unit_id, filter) => {
      if (unit_id) getScalesByUnitIds({ unit_id, filter });
    }, 500)
  ).current;

  const handleMenuOpen = () => {
    // Dispara a chamada à API apenas quando o menu é aberto
    debouncedGetScales(unit_id, filter);
  };

  const searchItem = (unitValue) => {
    setFilter((oldState) => ({
      ...oldState,
      page: 1,
      search: unitValue,
    }));
    debouncedGetScales(unit_id, { ...filter, search: unitValue });
  };

  React.useEffect(() => {
    if (data && data.length > 0) {
      const labelScale = data.map((scale) => ({
        labelSelected: showCount ? scale.name : undefined,
        label: `${scale.name}`,
        value: scale.id,
        status: scale.status,
      }));
      setFormattedLabels(labelScale.filter((item) => item.status !== 0));
    } else {
      setFormattedLabels([]);
    }
  }, [data]);

  return (
    <>
      <Select
        placeholder={placeholder}
        id={placeholder}
        isLoading={loading}
        loadingMessage={() => 'Carregando'}
        styles={customStyles(menuList)}
        name={name}
        options={formattedLabels}
        onInputChange={searchItem}
        onMenuOpen={handleMenuOpen} // Chama a API ao abrir o menu
        onChange={handleChange}
        value={value}
        noOptionsMessage={() => 'Nenhum resultado encontrado'}
        isMulti={isMulti}
        isClearable={isClearable}
      />
      {field ? (
        <ErrorMessage name={field.name}>
          {() => (
            <FormHelperText error id="component-error-text">
              {errors}
            </FormHelperText>
          )}
        </ErrorMessage>
      ) : (
        <>
          {errors && (
            <ErrorMessage name={name}>
              {() => (
                <FormHelperText error id="component-error-text">
                  {errors}
                </FormHelperText>
              )}
            </ErrorMessage>
          )}
        </>
      )}
    </>
  );
};

export default CustomSelectScales;
